import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
import { is8pxTheme } from "../../../lib/theming/ThemeHelpers";
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      box-sizing: content-box;\n      overflow: auto;\n      padding: ", " 0;\n    "])), t.menuBgDefault, is8pxTheme(t) ? 0 : t.menuPaddingY);
  },
  scrollContainer: function scrollContainer(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      padding: ", " 0;\n    "])), is8pxTheme(t) ? t.menuPaddingY : 0);
  },
  shadow: function shadow(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      border: ", ";\n      box-shadow: ", ";\n    "])), t.menuBorder, t.menuShadow);
  }
});